import { symbol } from "prop-types";
import { getCommonWidget } from "../../dashWidgetHelper";
import {
    PRODUTURO_SCALE_5_COLORS, PRODUTURO_PIE_COLORS, PRODUTURO_PIE_SINO_COLORS,
    commonWidgets, getProfuturoNpsPorMes,
    getProfuturoTreemap, getProfuturoNpsAcumuladoSemestral
} from "../commonWidgetsProfuturo";

const VALUATIONS_GROUPS: any = {
    0: '1°',
    1: '2°',
    2: '3°',
    3: '4°'
}

export default {
    title: 'Acompañamiento Dashboard',
    description: 'Acompañamiento Dashboard',
    backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI) => [
        {
            title: 'Principales Indicadores',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getProfuturoNpsAcumuladoSemestral({
            size: [1, 2],
            indicator: 'cuest_afore_v_ll_pregunta_2',
            extras: {
                periods: 6
            }

        }),

        getProfuturoNpsPorMes({
            helpText: 'A partir de tu experiencia, en una escala del 0 al 10, dónde 0 es nada probable y 10 muy probable, ¿qué tan probable es que nos recomiendes con un amigo o familiar?',
            size: [1, 2],
            indicator: 'cuest_afore_v_ll_pregunta_2',
            historicLabel: 'group',
            historicGrouped: 'responseValue',
            historicGroupByResponseValueId: 173003101
        }),
        getProfuturoTreemap({
            id: 'cuest_afore_v_ll_pregunta_2-treemap',
            title: 'Clientes Detractores',
            helpText: '¿Por qué nos diste esa calificación?',
            size: [2, 2],
            indicators: [
                { name: 'cuest_afore_v_ll_pregunta_3', formula: 'count-text', type: 'values' },
                { name: 'cuest_afore_v_ll_pregunta_3_count', type: 'count' },
            ],
        }),
        getProfuturoTreemap({
            id: 'cuest_afore_v_ll_pregunta_23-treemap',
            title: 'Clientes Neutros',
            size: [2, 2],
            helpText: '¿Cómo podríamos mejorar para que nos califiques con 9 o 10?',
            indicators: [
                { name: 'cuest_afore_v_ll_pregunta_23', formula: 'count-text', type: 'values' },
                { name: 'cuest_afore_v_ll_pregunta_23_count', type: 'count' },
            ],

        }),
        getProfuturoTreemap({
            id: 'cuest_afore_v_ll_pregunta_7-treemap',
            title: 'Clientes Promotores',
            helpText: '¿Qué fue lo que más valoraste?',
            size: [2, 2],
            indicators: [
                { name: 'cuest_afore_v_ll_pregunta_7', formula: 'count-text', type: 'values' },
                { name: 'cuest_afore_v_ll_pregunta_7_count', type: 'count' },
            ],

        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Contacto esperado',
            size: [2, 2],
            helpText: '¿Qué tipo de contacto esperas recibir de Profuturo?',
            indicator: 'cuest_afore_v_ll_pregunta_31',
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Medio de preferencia',
            size: [2, 2],
            helpText: '¿Por cuál medio te gustaría recibir información sobre tu Cuenta Individual?',
            indicator: 'cuest_afore_v_ll_pregunta_78',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Razón clave para ser cliente de Profuturo',
            size: [4, 2],
            helpText: '¿Cuál es el principal motivo por el que estás con Profuturo?',
            indicator: 'cuest_afore_v_ll_pregunta_9',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Recomendación',
            size: [2, 2],
            helpText: 'En el último año, ¿recomendaste a Profuturo a otras personas?',
            indicator: 'cuest_afore_v_ll_pregunta_18',
            extraConfigs: {
                colors: PRODUTURO_PIE_SINO_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Cantidad de personas recomendadas',
            size: [2, 2],
            helpText: '¿A cuántas personas le recomendaste pertenecer a Profuturo?',
            indicator: 'cuest_afore_v_ll_pregunta_19',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Permanencia',
            size: [1, 2],
            helpText: 'Si tu experiencia con Profuturo se mantiene igual que hasta ahora, ¿estarías dispuesto a seguir siendo nuestro cliente?',
            indicator: 'cuest_afore_v_ll_pregunta_76',
            extraConfigs: {
                colors: PRODUTURO_PIE_SINO_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Desistimiento',
            size: [3, 2],
            helpText: '¿Por qué razón no continuarías en Profuturo?',
            indicator: 'cuest_afore_v_ll_pregunta_20',
            extraConfigs: {
                itemGap: 10,
                center: ['27%', '55%'],
                colors: PRODUTURO_PIE_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'horizontalStackedBar',
            title: 'Ranking de atributos más valorados por los clientes',
            size: [2, 2],
            helpText: 'De la siguiente lista, coloca en primera posición lo que más valoras y en último lo que menos. En celular, mantén presionada cada opción 1 segundo para desplazarla',
            indicator: 'cuest_afore_v_ll_pregunta_40',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                layout: 'horizontal',
                valueSymbol: '%',
                groupKeys: Object.values(VALUATIONS_GROUPS),
                maxAxisXValue: 100,
                decimals: 1
            },
            extras: {
                decimals: 1,
            },
            extraIndicatorConfigs: {
                grouped: 'referenceAnswer,numberAnswer',
            },
            mapper: (data: any): any => {
                const valuations = Array.from(new Set(data.map((item: any) => item.groupId_0)))
                const groups = Array.from(new Set(data.map((item: any) => item.group)))

                const newData = groups?.map((group: any) => {
                    return valuations.reduce((acc: any, curr: any) => {
                        const value = data
                            ?.find((item: any) => item.groupId_0 === curr && item.group === group)
                            ?.value ?? 0

                        const valuation = VALUATIONS_GROUPS[curr]

                        return {
                            ...acc,
                            group: group,
                            groupName: group,
                            label: group,
                            [valuation]: value
                        }
                    }, {})
                })

                return newData
            },
        }),
        /*getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Ranking de atributos más valorados por los clientes',
            size: [2, 2],
            helpText: 'De la siguiente lista, coloca en primera posición lo que más valoras y en último lo que menos. En celular, mantén presionada cada opción 1 segundo para desplazarla',
            indicator: 'cuest_afore_v_ll_pregunta_40',
            extraConfigs: {
                itemGap: 10,
                center: ['27%', '55%'],
                colors: PRODUTURO_PIE_COLORS,
            },
            extras: {
                formula: 'count-number'
            }
        }),*/
        getCommonWidget({
            commonWidgets: commonWidgets,
            helpText: ' ¡Nos alegra escucharlo! ¿Nos podrías contar por qué?',
            name: 'wordCount',
            title: 'Motivos de lealtad',
            size: [2, 2],
            indicator: 'cuest_afore_v_ll_pregunta_45',
        }),


        /*{
            title: 'Ranking de atributos más valorados por los clientes',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'xxxx',
            size: [4, 1],
            helpText: 'xxxx',
            indicator: 'cuest_afore_v_ll_pregunta_11',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),*/

        {
            title: 'Atributos en la experiencia de Grado de SATISFACION',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La facilidad para comunicarse con Profuturo',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_11',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La rapidez y facilidad en los procesos / trámites',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_12',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La buena atención por parte del personal',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_13',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La recepción de mi Estado de Cuenta de manera puntual (cada 4 meses)',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_14',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'El cumplimiento con lo que me ofrecieron al momento de la contratación',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_15',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La asesoría y educación financiera recibida para planear mi futuro.',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_16',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La frecuencia con la que me contactan para informarme sobre mi Cuenta Individual',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_17',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'Las soluciones de los productos y servicios que me ofrecen para lograr mis metas financieras',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_afore_v_ll_pregunta_79',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Análisis de Sentimientos',
            position: [0, 3],
            size: [4, 4],
            indicator: 'SENTIMENT',
        }),

    ]
} as DasboardConfig